import { render, staticRenderFns } from "./ansReceiveFromNu.vue?vue&type=template&id=4894ec13&"
import script from "./ansReceiveFromNu.vue?vue&type=script&lang=js&"
export * from "./ansReceiveFromNu.vue?vue&type=script&lang=js&"
import style0 from "./ansReceiveFromNu.vue?vue&type=style&index=0&id=4894ec13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports